module.exports = {
    openGraphImage: '',
    openGraphSiteName: 'Car and Driver',
    openGraphType: 'website',
};
